import React, { FC } from "react"
import { ErrorBoundary as SentryErrorBoundary } from "@sentry/react"
import { ErrorFallback } from "./ErrorFallback"

interface ErrorBoundaryProps {
    message: string
}

export const ErrorBoundary: FC<ErrorBoundaryProps> = ({
    message,
    children
}) => {
    return (
        <SentryErrorBoundary fallback={<ErrorFallback title={message} />}>
            {children}
        </SentryErrorBoundary>
    )
}
